import { computed, toValue } from 'vue';
import { values } from 'lodash';

/**
 * Composable para la gestión de generación de suscripciones
 * @param {Ref|Object} infoServicio - Información del servicio (reactive o ref)
 * @param {Ref|Object} suscriptores - Objeto de suscriptores (reactive o ref)
 * @returns {Object} Computed properties y methods para generación de suscripciones
 */
export function useGeneracionSuscripciones(infoServicio, suscriptores) {
  // Computed properties
  const suscriptoresValores = computed(() => {
    const suscriptoresValue = toValue(suscriptores);
    return values(suscriptoresValue).filter((obj) => obj);
  });

  const numeroSuscriptores = computed(() => {
    const suscriptoresValue = toValue(suscriptores);
    return Object.keys(suscriptoresValue).length;
  });

  const esTransporte = computed(() => {
    const infoValue = toValue(infoServicio);
    return infoValue.transporteActivo && infoValue.servicio_tipo === 'transporte';
  });

  const esGenerico = computed(() => (
    // Hay tipo comedor pero no tiene gestión especial de momento y lo tomamos como genérico
    !esTransporte.value
  ));

  const esTransporteEventuales = computed(() => {
    const infoValue = toValue(infoServicio);
    return esTransporte.value && infoValue.tipoTransporte === 'eventuales';
  });

  const esMensual = computed(() => {
    const infoValue = toValue(infoServicio);
    return infoValue.mensual === true;
  });

  // Methods
  const nombreGrupo = (suscriptor) => {
    if (!suscriptor || !suscriptor.grupo_academico_principal) {
      return '';
    }
    return suscriptor.grupo_academico_principal.etiqueta
           || suscriptor.grupo_academico_principal.nombre;
  };

  return {
    // Computed properties
    suscriptoresValores,
    numeroSuscriptores,
    esGenerico,
    esTransporte,
    esTransporteEventuales,
    esMensual,
    // Methods
    nombreGrupo,
  };
}

// Export default para mantener compatibilidad con imports existentes
export default useGeneracionSuscripciones;
